import { RichTextViewer } from 'components/RichTextViewer'
import { Box } from 'grid'
import {
  Dialog,
  DialogType,
  IDialogProps,
  PrimaryButton,
  Stack,
} from 'office-ui-fabric-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useTheme } from 'theme'

export type ConfirmDeleteDialogProps = Omit<IDialogProps, 'modalProps'> & {
  titleText: string | undefined
  richText?: boolean
}

export const NotificationDialog: React.FunctionComponent<
  ConfirmDeleteDialogProps
> = ({ dialogContentProps, titleText, richText = false, ...props }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <Dialog
      dialogContentProps={{
        type: DialogType.normal,
        title:
          titleText ||
          'Bitte beheben Sie die Fehler im Formular und speichern bevor Sie fortfahren',
        ...dialogContentProps,
      }}
      {...props}
      subText={richText ? '' : props.subText}
      modalProps={{
        isBlocking: true,
        styles: { main: { minWidth: '33% !important' } },
      }}
    >
      {richText && <RichTextViewer richText={props.subText || ''} />}
      <Box mt={2}>
        <Stack
          tokens={{ childrenGap: theme.space![1] }}
          horizontal={true}
          horizontalAlign="end"
        >
          <Stack.Item>
            <PrimaryButton onClick={props.onDismiss as any}>
              {t('action.ok')}
            </PrimaryButton>
          </Stack.Item>
        </Stack>
      </Box>
    </Dialog>
  )
}

export default NotificationDialog
